import { Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { setShareResultsSettings, useReviewCreationData, useShareResultsSettings } from 'reducers/reviewCreationSlice';

import { ShareIcon } from 'assets/assetsV1/iconComponents';

import { REVIEW_PROVIDER_TYPES } from 'constants/ProjectConstants';

import {
  ExpandablePaper,
  ExpandablePaperBody,
  ExpandablePaperHeader,
} from 'uiToolkitV1/ExpandablePaper/ExpandablePaper';
import { RadioSelect } from 'uiToolkitV1/RadioSelect';
import { TooltipInfoV1 } from 'uiToolkitV1/TooltipInfoV1';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { ShareResultsSettings, useTemplateMetadata } from '../../Hooks/dataHooks/shareResultsDataHooks';

export const ShareResultSettings = ({ feedbackFormId }: { feedbackFormId: number }) => {
  const dispatch = useDispatch();
  const settings: ShareResultsSettings = useShareResultsSettings({ feedbackFormId });
  const { reviewCycleId } = useReviewCreationData();

  const hasManager = useTemplateMetadata({
    reviewCycleId,
    feedbackFormId,
    providerType: REVIEW_PROVIDER_TYPES.MANAGER,
  });

  const options = [];
  options.push({
    name: 'Admin publishes to manager or employee',
  });
  options.push({
    name: 'Manager or admin publishes to employee',
    isDisabled: !hasManager,
  });

  const handleChange = (index: number) => {
    dispatch(
      setShareResultsSettings({
        feedbackFormId,
        settings: { isManagerPublishAllowed: index === 1 },
      })
    );
  };

  return (
    <ExpandablePaper>
      <ExpandablePaperHeader
        title="Set the permission for publishing results"
        leftIconComponent={<ShareIcon boxSize="24px" color="icon.g2" />}
      />
      <ExpandablePaperBody p="8px 10px">
        <Flex flexDir="column" gap={3}>
          <Flex alignItems="center" gap={2}>
            <TextBodyMedium>Who shares the review results with employees:</TextBodyMedium>
            <TooltipInfoV1
              title={`Once a review has reached the 'Manager submitted' status it can be published. The review can be published for all or a selected set of employees. 
 If the  'Admin only' option is selected then the admin can publish directly to the employee or the manager. If the admin publishes to the manager then the manager can publish to the employee.
 If the 'Admin or Manager' option is selected then either can publish directly to the employee. In this option, the manager does not have to wait for the admin to publish to them first.
 Skip Managers have the same permission as the manager and Dotted Line managers do not have the permission to publish.`}
            />
          </Flex>
          <RadioSelect
            name=""
            options={options}
            onChange={handleChange}
            containerProps={{ mt: 0 }}
            selectedIndex={settings.isManagerPublishAllowed ? 1 : 0}
          />
        </Flex>
      </ExpandablePaperBody>
    </ExpandablePaper>
  );
};
